import React from 'react';
import type AdvancedRoadmapsPlanType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Page
 */

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAdvancedRoadmapsPlanExport = lazyForPaint<typeof AdvancedRoadmapsPlanType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-advanced-roadmaps-plan", jiraSpaEntry: "async-advanced-roadmaps-plan" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyAdvancedRoadmapsPlanExport}
		pageId="advanced-roadmaps-plan"
		shouldShowSpinner
	/>
);
